import React from "react";
type SectionProps = {
  id?: string;
  className?: string;
  children: React.ReactNode;
};
export function Section({
  id,
  className = "",
  children
}: SectionProps) {
  return <section id={id} className={`px-4 py-16 sm:px-6 md:py-24 ${className}`} data-id="element-60" data-mp="3fwdkkr5w59xn">
      <div className="mx-auto max-w-6xl" data-id="element-61" data-mp="3fyhrzj300r2o">{children}</div>
    </section>;
}
type HeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: "light" | "dark";
  align?: "center" | "left";
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = "light",
  align = "center"
}: HeadingProps) {
  const dark = tone === "dark";
  return <div className={align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"} data-id="element-62" data-mp="2pliax7sy85y">
      {eyebrow && <p className={`font-display text-sm font-semibold uppercase tracking-wider ${dark ? "text-sun" : "text-coral"}`} data-id="element-63" data-mp="7mvf4xxitm3t">
          {eyebrow}
        </p>}
      <h2 className={`mt-2 text-balance font-display text-[30px] font-bold leading-[1.1] sm:text-4xl md:text-[44px] ${dark ? "text-white" : "text-navy"}`} data-id="element-64" data-mp="106apz7jfo4n9">
        {title}
      </h2>
      {intro && <div className={`mt-4 text-lg leading-relaxed ${dark ? "text-white/85" : "text-ink/80"}`} data-id="element-65" data-mp="2uje96q1l81ed">{intro}</div>}
    </div>;
}